import React from 'react';
import { Quote } from 'acscp/store';
import { ViewPdfButton } from 'acscp/components/viewPdf/viewPdfButton';
import { QuotePdfUrlRequest } from 'acscp/api/requests';
import { AcceptQuoteButton } from 'acscp/components/quotes/acceptQuoteButton';
import { CharterPrice } from 'acscp/components/quotes/quoteDetails';
import style from './quoteButtons.module.scss';
import { Department } from 'acscp/api/models/customTypes/department';
import classNames from 'classnames';
import { QuoteType } from 'acscp/api/models/customTypes/quoteType';
import { isQuoteInAcmiWorkflow } from 'acscp/store/helpers/quoteHelper';

const QuoteButtons: React.FC<{
    quote: Quote,
    className: string,
    jetCardHolder: boolean,
    showAcceptButton: boolean,
    disabled?: boolean
}>
    = ({
        quote,
        className,
        jetCardHolder,
        showAcceptButton,
        disabled,
    }) => {
    const isInAcmiWorkflow = isQuoteInAcmiWorkflow(quote);
    return(
        <div className={className}>
            {!showAcceptButton && quote.sellPrice !== null && !isInAcmiWorkflow &&
                <CharterPrice
                    quote={quote}
                    jetCardHolder={jetCardHolder}
                    className={classNames(
                        style.CharterPrice,
                        {[style.CharterPriceCargo]: quote.department === Department.Cargo}
                    )}
                    labelClassName={classNames(
                        style.CharterPriceLabel,
                        {[style.CharterPriceLabelCargo]: quote.department === Department.Cargo}
                    )}
                    currencyClassName={style.CharterPriceCurrency}
                    priceClassName={style.CharterPriceAmount}
                    amexClassName={style.AmexNote}
                />
            }
            {quote.quoteType !== QuoteType.OBC && (
                <ViewPdfButton
                    pdfUrlRequest={new QuotePdfUrlRequest(quote.id)}
                    pdfId={quote.id}
                    isGreyedOut={disabled}
                    isDarkBlue={quote.department === Department.Cargo}
                />
            )}
            {showAcceptButton && (
                <AcceptQuoteButton quote={quote} jetCardHolder={jetCardHolder} disabled={disabled}/>
            )}
        </div>
    );
};

export {QuoteButtons};
